var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.user.role === 'admin')?_c('AdminDashboard'):(_vm.user.role === 'builder')?_c('BuilderDashboard'):_c('PlatformDashboard')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }